import React from "react";
import {
  Video,
  Image,
  ComponentProps,
  ComponentWidth,
  PageLink,
} from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import { Link } from "../../elements/Link/Link";
import VideoPlayer from "../../elements/VideoPlayer/VideoPlayer";
import * as styles from "./Resources.module.css";

interface Props extends ComponentProps, ComponentWidth {
  heading?: string;
  resources: (
    | Video
    | {
        image: Image;
        link: PageLink;
      }
  )[];
}

export const Resources: React.FC<Props> = ({
  heading,
  resources,
  width,
  ...props
}) => {
  const classes = [styles.resources];
  width === "contained" && classes.push(styles.contained);

  const renderResources = () => {
    return resources.map((resource, idx) => (
      <div key={`resource${idx}`} className={styles.resource}>
        {renderMedia(resource)}
      </div>
    ));
  };

  const renderMedia = (media: any) => {
    if (media?.videoUrl) {
      return (
        <>
          <div className={styles.media}>
            <VideoPlayer
              className={styles.video}
              src={media?.videoUrl}
              thumbnail={media?.thumbnail?.item?.url}
              display="overlay"
              arrowSize="46px"
            />
          </div>
          <div className={styles.title}>{media?.name}</div>
        </>
      );
    }

    return (
      <Link to={media?.link?.href} target={media?.link?.target}>
        <div className={styles.media}>
          <KontentImageElement
            aspectRatio={16 / 9}
            objectFit="cover"
            layout="fullWidth"
            image={media?.image?.item}
            alt={media?.image?.alt}
            className={styles.image}
          />
        </div>
        <div className={styles.title}>{media?.link?.label}</div>
      </Link>
    );
  };

  return (
    <SectionWrapper {...props}>
      <div className={classes.join(" ")}>
        {heading && <h2 data-kontent-element-codename="heading">{heading}</h2>}
        <div
          className={styles.content}
          data-kontent-element-codename="resources"
        >
          {renderResources()}
        </div>
      </div>
    </SectionWrapper>
  );
};
